/**
 * @flow
 * @relayHash 1e7e9f381240d1c02ec59540285e34b6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DestinationClassificationType = "COMMERCIAL" | "HOUSE" | "RESIDENTIAL_BUILDING" | "UNDEFINED" | "%future added value";
export type PackageTrackerAddressClassificationMutationInput = {|
  packageId: number,
  classificationType?: ?DestinationClassificationType,
  instructions?: ?string,
  additionalReceivers?: ?string,
  clientMutationId?: ?string,
|};
export type classificationMutationVariables = {|
  input: PackageTrackerAddressClassificationMutationInput
|};
export type classificationMutationResponse = {|
  +packageTrackerAddressClassification: ?{|
    +success: ?boolean,
    +errors: ?$ReadOnlyArray<{|
      +message: ?string
    |}>,
  |}
|};
export type classificationMutation = {|
  variables: classificationMutationVariables,
  response: classificationMutationResponse,
|};
*/

/*
mutation classificationMutation(
  $input: PackageTrackerAddressClassificationMutationInput!
) {
  packageTrackerAddressClassification(input: $input) {
    success
    errors {
      message
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'input',
        type: 'PackageTrackerAddressClassificationMutationInput!',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'packageTrackerAddressClassification',
        storageKey: null,
        args: [
          {
            kind: 'Variable',
            name: 'input',
            variableName: 'input'
          }
        ],
        concreteType: 'PackageTrackerAddressClassificationMutation',
        plural: false,
        selections: [
          {
            kind: 'ScalarField',
            alias: null,
            name: 'success',
            args: null,
            storageKey: null
          },
          {
            kind: 'LinkedField',
            alias: null,
            name: 'errors',
            storageKey: null,
            args: null,
            concreteType: 'ErrorNode',
            plural: true,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'message',
                args: null,
                storageKey: null
              }
            ]
          }
        ]
      }
    ];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'classificationMutation',
      type: 'Mutation',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    operation: {
      kind: 'Operation',
      name: 'classificationMutation',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    params: {
      operationKind: 'mutation',
      name: 'classificationMutation',
      id: null,
      text:
        'mutation classificationMutation(\n  $input: PackageTrackerAddressClassificationMutationInput!\n) {\n  packageTrackerAddressClassification(input: $input) {\n    success\n    errors {\n      message\n    }\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = 'e71f72cfe0ecddbd0ddd8c521331b288';
module.exports = node;
